define(["knockout", "@modules/tools/urlParameters", "querystring"], function (ko, urlParameters, querystring) {
    function cleanupUrl(baseUrl, queryObject) {
        return baseUrl + "?" + querystring.stringify(urlParameters.reduceParams(queryObject, {}));
    }

    // SalesEventDialogViewModel ctor
    return function (seminarUrl) {
        var self = this;

        self.eventDialogZipOrAddress = ko.observable();

        self.baseSeminarLink = ko.observable(seminarUrl);

        self.seminarSearchUrl = ko.computed(function () {
            var baseUrl = self.baseSeminarLink();
            var query = {
                seminarQuery: self.eventDialogZipOrAddress()
            };
            return cleanupUrl(baseUrl, query);
        }, this);

        self.submitOnEnter = function (data, event) {
            if (event.keyCode === 13) {
                window.location.href = self.seminarSearchUrl();
            }
            return true;
        };
    };
});
